import { I18n } from '@calendly/i18n'

class ChangeSet {
  constructor() {
    this.changes = {}
    this.dirtyNavigation = false
  }

  allowDirtyNavigation() {
    this.dirtyNavigation = true
  }

  disableDirtyNavigation() {
    this.dirtyNavigation = false
  }

  confirmReset() {
    if (!this.isDirty()) {
      return true
    }

    if (window.confirm(this.getMessage())) {
      this.reset()

      return true
    }

    return false
  }

  isDirty(id = null) {
    if (id) return !!this.changes[id]

    return Object.values(this.changes).length > 0
  }

  getLastPath() {
    return Object.values(this.changes).at(-1)
  }

  dirty(id) {
    this.checkIdArgument(id)
    this.changes[id] = window.location.pathname
    this.attachWindowHandler()
  }

  clear(id) {
    this.checkIdArgument(id)
    delete this.changes[id]
    if (!this.isDirty()) {
      this.detachWindowHandler()
    }
  }

  reset() {
    this.changes = {}
    this.dirtyNavigation = false
    this.detachWindowHandler()
  }

  confirmNavigation = (_message, callback) => {
    this.confirmResetAsync()
      .then(() => callback(true))
      .catch(() => {
        window.history.pushState({}, null, this.getLastPath())
      })
  }

  shouldBlockNavigation = () => {
    if (this.dirtyNavigation) return null
    if (this.isDirty()) {
      return this.getMessage()
    }
    return null
  }

  // private

  confirmResetAsync() {
    return new Promise((resolve, reject) => {
      if (!this.isDirty()) {
        return resolve()
      }

      if (window.confirm(this.getMessage())) {
        this.reset()

        return resolve()
      }

      return reject()
    })
  }

  getMessage() {
    return `${I18n.t('publisher.components.dirty_form.been_editing')}
${I18n.t('publisher.components.dirty_form.changes_lost')}`
  }

  checkIdArgument(id) {
    if (id == null) {
      throw new Error('id argument is required')
    }
  }

  attachWindowHandler() {
    window.onbeforeunload = (event) => {
      (event || {}).returnValue = this.getMessage()

      return this.getMessage()
    }
  }

  detachWindowHandler() {
    window.onbeforeunload = null
  }
}

export default new ChangeSet()
